/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddDiscount1Request } from './addDiscount1Request';
import { AccessPlanItem } from './accessPlanItem';


export interface AccessPlan { 
    id?: number;
    name?: string;
    cpfcnpj?: string;
    payerCnpj?: string;
    payerAccepted?: boolean;
    packageType?: AccessPlan.PackageTypeEnum;
    active?: boolean;
    autoRenew?: boolean;
    createdAt?: string;
    updatedAt?: string;
    expiresAt?: string;
    lastPaymentDate?: string;
    nextPaymentDate?: string;
    paymentRequestedAt?: string;
    upgradedFromPlanId?: number;
    upgradeDate?: string;
    upgradeReason?: string;
    items?: Array<AccessPlanItem>;
    discounts?: Array<AddDiscount1Request>;
    freePlan?: boolean;
    inTrialPeriod?: boolean;
    expired?: boolean;
    effectivePayerCnpj?: string;
    readyForActivation?: boolean;
    upgradedPlan?: boolean;
    readonly finalTotal?: number;
    readonly totalDiscounts?: number;
    readonly grossTotal?: number;
}
export namespace AccessPlan {
    export type PackageTypeEnum = 'SUBSCRIPTION_PROVIDER_PF_FREE' | 'SUBSCRIPTION_PROVIDER_PF_BASIC' | 'SUBSCRIPTION_LAB_FREE' | 'SUBSCRIPTION_LAB_BASIC' | 'SUBSCRIPTION_PROVIDER_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_PJ_2' | 'SUBSCRIPTION_PROVIDER_PJ_6' | 'SUBSCRIPTION_PROVIDER_PJ_10' | 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_CONTRACTOR_PJ_120' | 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_ADMINISTRATOR';
    export const PackageTypeEnum = {
        ProviderPfFree: 'SUBSCRIPTION_PROVIDER_PF_FREE' as PackageTypeEnum,
        ProviderPfBasic: 'SUBSCRIPTION_PROVIDER_PF_BASIC' as PackageTypeEnum,
        LabFree: 'SUBSCRIPTION_LAB_FREE' as PackageTypeEnum,
        LabBasic: 'SUBSCRIPTION_LAB_BASIC' as PackageTypeEnum,
        ProviderPjFree: 'SUBSCRIPTION_PROVIDER_PJ_FREE' as PackageTypeEnum,
        ProviderPj2: 'SUBSCRIPTION_PROVIDER_PJ_2' as PackageTypeEnum,
        ProviderPj6: 'SUBSCRIPTION_PROVIDER_PJ_6' as PackageTypeEnum,
        ProviderPj10: 'SUBSCRIPTION_PROVIDER_PJ_10' as PackageTypeEnum,
        ProviderPjPersonal: 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' as PackageTypeEnum,
        ProviderContractorPjFree: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' as PackageTypeEnum,
        ProviderContractorPj100: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' as PackageTypeEnum,
        ProviderContractorPjPersonal: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' as PackageTypeEnum,
        ContractorPj120: 'SUBSCRIPTION_CONTRACTOR_PJ_120' as PackageTypeEnum,
        ContractorPjPersonal: 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' as PackageTypeEnum,
        Administrator: 'SUBSCRIPTION_ADMINISTRATOR' as PackageTypeEnum
    };
}


